import { format } from "date-fns"
import { da, de, enUS, es, fi, fr, nb, nl, pl, pt, sv } from "date-fns/locale"
import type { Locale as DateFnsLocale } from "date-fns/locale"
import { isValidLocale, type Locale } from "./locales"

export const dateFnsLocales: Record<Locale, DateFnsLocale> = {
  es_ES: es,
  fr_FR: fr,
  da_DK: da,
  en_US: enUS,
  de_DE: de,
  nb_NO: nb,
  sv_SE: sv,
  pt_PT: pt,
  fi_FI: fi,
  pl_PL: pl,
  nl_NL: nl,
}

export function getDateFnsLocale(locale: string): DateFnsLocale {
  return isValidLocale(locale) ? dateFnsLocales[locale] : enUS
}

export function formatTime(duration: number): string {
  const m = Math.floor((duration % 3600) / 60)
      .toString()
      .padStart(2, "0"),
    s = Math.floor(duration % 60)
      .toString()
      .padStart(2, "0")

  return `${m}:${s}`
}

export function formatDate(date: Date, locale?: string): string {
  if (locale) return format(date, "P", { locale: getDateFnsLocale(locale) })

  const day = date.getDate().toString().padStart(2, "0"),
    month = (date.getMonth() + 1).toString().padStart(2, "0"),
    year = date.getFullYear().toString()

  return `${day}-${month}-${year}`
}
